import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import StoryComponentLiveBlog from "../../story-component-live-blog";
import PaywallComponent from "../paywall-not-logged-user";
import { isFreeLimit } from "../../../utils/isFreeLimit";
import PaywallLoggedUser from "../paywall-logged-user";
import PaywallOneDay from "../one-day-paywall";
import useStorage from "../../../../hook/useStorage";
import StoryComponent from "../../story-component";
import useUrl from "../../../../hook/useUrl";
import Tags from "../../../molecules/tags";
import './story-paywall-component.m.css';
import LoginPaywallComponent from "../login-paywall-not-logged-user/paywall-accesstype-login";
import { get } from "lodash";
import { CoralCommenting } from "../../coral-commenting";
import NewuoStoryBox from "../../../molecules/newuo-storybox";
import useNewuo from "../../../../hook/useNewuo";
import useGeneralAccessType from "../../../../hook/use-general-accesstype";
import { generatePaperValues } from "../../../utils/generate-paper-values";

const StoryPaywallComponent = ({ story, showAds = true, allTextVideo, customTemplateVideo }) => {

  const [ isDisplayed, setIsDisplayed] = useState(false);
  const [_,currentUrlSlug]=useUrl();
  const allText = story.cards[0]["story-elements"][0] || allTextVideo;
  const text = ((allText && allText.text) || allTextVideo) ? ( allText.text && (allText.text.length >= 280 ?
    allText.text.slice(0, 280).concat(`<span>...</span>`) :
    allText.text.slice(0, allText.text.length - 1).concat(`<span>...</span>`)))
    : "";
  const customTemplate = ({ element }) => <div styleName="upper-para" className="upper-para" dangerouslySetInnerHTML={{ __html: text }} /> || customTemplateVideo;
  const storyTemplate = story["story-template"];

  // Use the custom hook to get the general access type that overrides story's own access type.
  // Can be used for opening up the site for everyone or to set stories behind login instead of subscription.
  // If access level is not 2 or 3, use story's own access level.
  let accessType = useGeneralAccessType(story.access);

  // for epari and vaasa stories, set accessType to public
  if((currentUrlSlug==="vaasalehti") || (currentUrlSlug==="epari")){
    accessType="public";
  }


  //console.log(accessType, "generalAccessType");

  const [checkUser, activeProducts, whiteListed, allTagIds,visitCounts,articlesLimit,isVisitedSlug] = useStorage();
  const conditionalComponents = isFreeLimit(checkUser, activeProducts,whiteListed,visitCounts,articlesLimit,isVisitedSlug);
  const loginAccessType = (accessType === "login");
  const subscriptionAccessType = ((accessType === null) || (accessType === "subscription"));
  const isCommentingOn = get(story, ["metadata", "story-attributes", "kommentointi", 0]);
  const storyObj = story.story ? story.story : story;
  const coralUrl = (storyObj && storyObj.url && storyObj.url.includes("fiare.qtstage.io")) ? "https://coraldev.fluentia.fi" : "https://keskustelu.ilkkapohjalainen.fi";
  const [similarStories,showNewuo] = useNewuo(storyObj);
  var paperValues = generatePaperValues(storyObj);


  useEffect(() => {
    // Append coral script for getting comment count to head
    const script = document.createElement('script');
    script.src = `${coralUrl}/assets/js/count.js`;
    script.async = false;
    script.defer = true;
    script.className = 'coral-script';
    document.head.appendChild(script);
  }, []); // Empty dependency array ensures this runs once on mount

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      accessLevel: story.access
    });
    setTimeout(
      () => {
        setIsDisplayed(true);
      }, !checkUser?1000:0);
  }, []);

  return (
    <>
      {/*paywall for logged in user*/}
      {(subscriptionAccessType) && conditionalComponents === false && storyTemplate !== "pivmuuri" &&
        isDisplayed && <div><PaywallLoggedUser element={allText} text={customTemplate} /></div>}

      {/* paywall for not logged in user */}
      {(subscriptionAccessType) && conditionalComponents === null && storyTemplate !== "pivmuuri" &&
        isDisplayed && <div><PaywallComponent element={allText} text={customTemplate} /></div>}

      {/* paywall for not logged in and logged in user (non-subscriber) if story template is päivämuuri */}
      {subscriptionAccessType && (conditionalComponents === false || conditionalComponents === null) && storyTemplate === "pivmuuri" &&
        isDisplayed && <div><PaywallOneDay isFree={conditionalComponents} element={allText} text={customTemplate} /></div>}

      {/*Paywall for stories that have accessLevel "login" - shown for non-logged in users */}
      {(loginAccessType) && conditionalComponents === null &&
        isDisplayed && <div><LoginPaywallComponent element={allText} text={customTemplate} /></div>}

      {/* User is subscriber -> show story component */}
      {((subscriptionAccessType) || (loginAccessType)) && (conditionalComponents === true || (checkUser && !activeProducts && (loginAccessType))) && storyTemplate !== "live-blog" &&
        <div><StoryComponent story={story} showAds={showAds} allTagIds={allTagIds} /></div>}

      {/* User is subscriber and story template is live-blog -> show story component for live-blog */}
      {((subscriptionAccessType) || (loginAccessType)) && (conditionalComponents === true || (checkUser && !activeProducts && (loginAccessType))) && storyTemplate === "live-blog" &&
        <div><StoryComponentLiveBlog story={story} /></div>}

      {/* If accessType is yleinen, story is not behind paywall -> show story component */}
      {(!subscriptionAccessType && !loginAccessType) && storyTemplate !== "live-blog" && <StoryComponent story={story} showAds={showAds} allTagIds={allTagIds} />}

      {/* If accessType is yleinen and story template is live-blog  -> show story component for live-blog */}
      {(!subscriptionAccessType && !loginAccessType) && storyTemplate === "live-blog" && <StoryComponentLiveBlog story={story} />}

      {/* List of tags that are marked to story */}
      {<Tags tags={story.tags} place={"story-page"} />}

      {/* Show commenting if not wow/native, user is not whitelisted and commenting is not set off from Bold */}
      {((storyTemplate !== "wau-juttu" && storyTemplate !=="natiivi") && !whiteListed &&  (isCommentingOn !== "pois")) && <CoralCommenting story={story} />}
      {((storyTemplate !== "wau-juttu") && showNewuo) ? (
        similarStories && similarStories.length > 0 ? (
          <div styleName="newuo-widget" className="voice-no-read">
            <h2 styleName="top-headline-neuwo">Sinua saattaisi myös kiinnostaa</h2>
            <div>
              {similarStories &&
                similarStories.map((item) => {
                  return (
                    <div>
                      <NewuoStoryBox
                        articleURL={item.articleURL}
                        imageSrc={item.imageURL && item.imageURL}
                        publicationID={paperValues.paperName}
                        headline={item.headline}
                        publishedDate={item.published}
                        pubDate={item.details.story["published-at"]}
                        accessType={item.details.story.access}
                        score={item.score}
                        storyObj
                      />{" "}
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          /*console.log("No similar articles found")*/
            null
        )
      ) : (
        null
      )}
    </>
  )
}

StoryPaywallComponent.propTypes = {
  story: object
};

export default StoryPaywallComponent;
